import { gql } from '@apollo/client';

export const UPDATE_USER_SETTINGS = gql`
  mutation updateUserSettings($input: UpdateUserSettingsInput!) {
    updateUserSettings(updateUserSettingsInput: $input) {
      success
      error
      user {
        id
        firstName
        lastName
        email
        phoneNumber
        isActive
        emailNotifications
        mobilePushNotifications
        timezone
        timezoneDisplayPreference
        userGroups {
          id
          name
          cognitoGroupName
          displayColour
        }
        tags {
          id
          name
          displayColour
          archived
        }
        brands {
          id
          name
          archived
        }
      }
    }
  }
`;
